// FoodNutrientsTable.js
const foodData = [
  {
    food: "M&M’s Biasa",
    type: "Camilan",
    serving: "bungkus",
    size: 1,
    weight: 48,
    protein: 3.02,
    fat: 10.66,
    carbohydrates: 32.74,
    calories: 228.48,
    sugar: null,
  },
  {
    food: "Nasi (matang)",
    type: "Roti dan Sereal",
    serving: "gelas",
    size: 1,
    weight: 158,
    protein: 4.25,
    fat: 0.44,
    carbohydrates: 44.51,
    calories: 205.4,
    sugar: null,
  },
  {
    food: "Alpukat",
    type: "Buah-buahan",
    serving: "gelas",
    size: 1,
    weight: 146,
    protein: 2.9,
    fat: 21.4,
    carbohydrates: 12.5,
    calories: 233.6,
    sugar: 1,
  },
  {
    food: "Ilbah",
    type: "Makanan Populer",
    serving: "setengah gelas",
    size: 0.5,
    weight: 100,
    protein: 4.3,
    fat: 3.3,
    carbohydrates: 17.8,
    calories: 118,
    sugar: null,
  },
  {
    food: "Alu",
    type: "Makanan Populer",
    serving: "3 buah",
    size: 3,
    weight: 100,
    protein: 2.63,
    fat: 4.86,
    carbohydrates: 20.6,
    calories: 136,
    sugar: null,
  },
  {
    food: "Nanas",
    type: "Buah-buahan",
    serving: "gelas",
    size: 1,
    weight: 155,
    protein: 0.8,
    fat: 0.2,
    carbohydrates: 20.3,
    calories: 77.5,
    sugar: 14.4,
  },
  {
    food: "Nanas Kaleng",
    type: "Minuman",
    serving: "gelas",
    size: 1,
    weight: 255,
    protein: 0.89,
    fat: 0.28,
    carbohydrates: 51.51,
    calories: 198.9,
    sugar: null,
  },
  {
    food: "Omelet",
    type: "Telur",
    serving: "butir",
    size: 1,
    weight: 61,
    protein: 6.5,
    fat: 7.3,
    carbohydrates: 0.4,
    calories: 95.8,
    sugar: 0.4,
  },
  {
    food: "Es Krim Vanila",
    type: "Camilan",
    serving: "setengah gelas",
    size: 0.5,
    weight: 90,
    protein: 4.62,
    fat: 14.52,
    carbohydrates: 31.15,
    calories: 265.32,
    sugar: null,
  },
  {
    food: "Es Krim Stroberi",
    type: "Camilan",
    serving: "setengah gelas",
    size: 0.5,
    weight: 90,
    protein: 4.22,
    fat: 11.09,
    carbohydrates: 36.43,
    calories: 253.44,
    sugar: null,
  },
  {
    food: "Es Krim Cokelat",
    type: "Camilan",
    serving: "setengah gelas",
    size: 0.5,
    weight: 91,
    protein: 4.2,
    fat: 14.9,
    carbohydrates: 20.2,
    calories: 232,
    sugar: null,
  },
  {
    food: "Sandwich Es Krim",
    type: "Camilan",
    serving: "potong",
    size: 1,
    weight: 63,
    protein: 3,
    fat: 6,
    carbohydrates: 27,
    calories: 170,
    sugar: null,
  },
  {
    food: "Kacang Polong Hijau",
    type: "Sayuran",
    serving: "gelas",
    size: 1,
    weight: 160,
    protein: 8.6,
    fat: 0.4,
    carbohydrates: 25,
    calories: 134.4,
    sugar: 9.5,
  },
  {
    food: "Jeruk",
    type: "Buah-buahan",
    serving: "satu sedang",
    size: 1,
    weight: 131,
    protein: 1.2,
    fat: 0.2,
    carbohydrates: 15.4,
    calories: 61.6,
    sugar: 12.2,
  },
  {
    food: "Ubi Jalar",
    type: "Sayuran",
    serving: "satu sedang",
    size: 1,
    weight: 130,
    protein: 2,
    fat: 0.1,
    carbohydrates: 26.2,
    calories: 111.8,
    sugar: 5.4,
  },
  {
    food: "Peterseli",
    type: "Sayuran",
    serving: "10 tangkai",
    size: 10,
    weight: 10,
    protein: 0.3,
    fat: 0.1,
    carbohydrates: 0.6,
    calories: 3.6,
    sugar: 0.1,
  },
  {
    food: "Lupin",
    type: "Sayuran",
    serving: "gelas",
    size: 1,
    weight: 166,
    protein: 25.8,
    fat: 4.8,
    carbohydrates: 16.4,
    calories: 197.5,
    sugar: null,
  },
  {
    food: "Kurma",
    type: "Buah-buahan",
    serving: "4 butir",
    size: 4,
    weight: 32,
    protein: 0.8,
    fat: 0.1,
    carbohydrates: 24,
    calories: 90.2,
    sugar: 20.3,
  },
  {
    food: "Blueberry",
    type: "Buah-buahan",
    serving: "gelas",
    size: 1,
    weight: 145,
    protein: 1.1,
    fat: 0.5,
    carbohydrates: 21,
    calories: 82.6,
    sugar: 14.4,
  },
  {
    food: "Blackberry",
    type: "Buah-buahan",
    serving: "gelas",
    size: 1,
    weight: 144,
    protein: 2,
    fat: 0.7,
    carbohydrates: 13.8,
    calories: 61.9,
    sugar: 7,
  },
  {
    food: "Cranberry",
    type: "Buah-buahan",
    serving: "gelas",
    size: 1,
    weight: 95,
    protein: 0.4,
    fat: 0.1,
    carbohydrates: 11.6,
    calories: 43.7,
    sugar: 3.8,
  },
  {
    food: "Buah Tin",
    type: "Buah-buahan",
    serving: "satu sedang",
    size: 1,
    weight: 50,
    protein: 0.4,
    fat: 0.2,
    carbohydrates: 9.6,
    calories: 37,
    sugar: 8.1,
  },
  {
    food: "Arugula",
    type: "Sayuran",
    serving: "gelas",
    size: 1,
    weight: 34,
    protein: 0.8,
    fat: null,
    carbohydrates: 0.4,
    calories: 3.7,
    sugar: 0.1,
  },
  {
    food: "Persik",
    type: "Buah-buahan",
    serving: "satu sedang",
    size: 1,
    weight: 150,
    protein: 1.4,
    fat: 0.4,
    carbohydrates: 14.3,
    calories: 58.5,
    sugar: 12.6,
  },
  {
    food: "Persik Kering",
    type: "Buah-buahan",
    serving: "gelas (setengah)",
    size: 0.5,
    weight: 160,
    protein: 5.8,
    fat: 1.2,
    carbohydrates: 98.1,
    calories: 382.4,
    sugar: 66.8,
  },
  {
    food: "Krokot",
    type: "Sayuran",
    serving: "gelas",
    size: 1,
    weight: 43,
    protein: 0.6,
    fat: null,
    carbohydrates: 1.5,
    calories: 6.9,
    sugar: null,
  },
  {
    food: "Bayam",
    type: "Sayuran",
    serving: "gelas",
    size: 1,
    weight: 30,
    protein: 0.9,
    fat: 0.1,
    carbohydrates: 1.1,
    calories: 6.9,
    sugar: 0.1,
  },
  {
    food: "Melon",
    type: "Buah-buahan",
    serving: "gelas (potongan)",
    size: 1,
    weight: 177,
    protein: 1.5,
    fat: 0.3,
    carbohydrates: 14.4,
    calories: 60.2,
    sugar: 13.9,
  },
  {
    food: "Kacang Hitam",
    type: "Sayuran",
    serving: "gelas",
    size: 1,
    weight: 164,
    protein: 14.5,
    fat: 4.2,
    carbohydrates: 45,
    calories: 269,
    sugar: 7.9,
  },
  {
    food: "Kacang Buncis",
    type: "Sayuran",
    serving: "gelas",
    size: 1,
    weight: 177,
    protein: 15.3,
    fat: 0.9,
    carbohydrates: 40.4,
    calories: 224.8,
    sugar: 0.6,
  },
  {
    food: "Kacang Buncis Hijau",
    type: "Sayuran",
    serving: "gelas",
    size: 1,
    weight: 110,
    protein: 2,
    fat: 0.1,
    carbohydrates: 7.8,
    calories: 34.1,
    sugar: 1.5,
  },
  {
    food: "Lobak Merah",
    type: "Sayuran",
    serving: "irisan (setengah gelas)",
    size: 0.5,
    weight: 58,
    protein: 0.4,
    fat: 0.1,
    carbohydrates: 2,
    calories: 9.3,
    sugar: 1.2,
  },
  {
    food: "Kembang Kol",
    type: "Sayuran",
    serving: "gelas",
    size: 1,
    weight: 100,
    protein: 2,
    fat: 0.1,
    carbohydrates: 5.3,
    calories: 25,
    sugar: 2.4,
  },
  {
    food: "Bawang Perai",
    type: "Sayuran",
    serving: "4 sendok teh",
    size: 4,
    weight: 40,
    protein: 1,
    fat: null,
    carbohydrates: 6.7,
    calories: 28.8,
    sugar: null,
  },
  {
    food: "Cerry Asam",
    type: "Buah-buahan",
    serving: "gelas",
    size: 1,
    weight: 103,
    protein: 1,
    fat: 0.3,
    carbohydrates: 12.5,
    calories: 51.5,
    sugar: 8.7,
  },
  {
    food: "Cerry Manis",
    type: "Buah-buahan",
    serving: "gelas",
    size: 1,
    weight: 117,
    protein: 1.2,
    fat: 0.2,
    carbohydrates: 18.7,
    calories: 73.7,
    sugar: 15,
  },
  {
    food: "Ketumbar",
    type: "Sayuran",
    serving: "9 tangkai",
    size: 9,
    weight: 20,
    protein: 0.4,
    fat: 0.1,
    carbohydrates: 0.7,
    calories: 4.6,
    sugar: 0.2,
  },
  {
    food: "Lobak",
    type: "Sayuran",
    serving: "gelas iris",
    size: 1,
    weight: 67,
    protein: 2.2,
    fat: 0.5,
    carbohydrates: 6.7,
    calories: 33.5,
    sugar: null,
  },
  {
    food: "Amus",
    type: "Makanan Populer",
    serving: "setengah gelas",
    size: 0.5,
    weight: 100,
    protein: 6.84,
    fat: 1.7,
    carbohydrates: 26.81,
    calories: 149.9,
    sugar: null,
  },
  {
    food: "Pepaya",
    type: "Buah-buahan",
    serving: "satu sedang",
    size: 1,
    weight: 304,
    protein: 1.9,
    fat: 0.4,
    carbohydrates: 29.8,
    calories: 118.6,
    sugar: 17.9,
  },
  {
    food: "Bajelah",
    type: "Makanan Populer",
    serving: "setengah gelas",
    size: 0.5,
    weight: 100,
    protein: 6.2,
    fat: 1,
    carbohydrates: 16.3,
    calories: 99,
    sugar: null,
  },
  {
    food: "Terong",
    type: "Sayuran",
    serving: "setengah gelas",
    size: 0.5,
    weight: 82,
    protein: 0.84,
    fat: 0.15,
    carbohydrates: 4.98,
    calories: 21.32,
    sugar: null,
  },
  {
    food: "Kacang Polong Beku",
    type: "Sayuran",
    serving: "gelas",
    size: 1,
    weight: 63,
    protein: 1.8,
    fat: 0.1,
    carbohydrates: 4.8,
    calories: 26.5,
    sugar: 2.5,
  },
  {
    food: "M&M’s Kacang Hazelnut",
    type: "Camilan",
    serving: "satu bungkus",
    size: 1,
    weight: 49,
    protein: 5.24,
    fat: 13.18,
    carbohydrates: 28.91,
    calories: 242.55,
    sugar: null,
  },
  {
    food: "Okra",
    type: "Sayuran",
    serving: "gelas",
    size: 1,
    weight: 100,
    protein: 2,
    fat: 0.1,
    carbohydrates: 7,
    calories: 31,
    sugar: 1.2,
  },
  {
    food: "Batsith",
    type: "Makanan Populer",
    serving: "setengah gelas",
    size: 0.5,
    weight: 100,
    protein: 2.6,
    fat: 6.4,
    carbohydrates: 71,
    calories: 352,
    sugar: null,
  },
  {
    food: "Bakhari Ayam",
    type: "Makanan Populer",
    serving: "setengah gelas",
    size: 0.5,
    weight: 100,
    protein: 18.6,
    fat: 2.8,
    carbohydrates: 17.4,
    calories: 169,
    sugar: null,
  },
  {
    food: "Bakhari Daging",
    type: "Makanan Populer",
    serving: "setengah gelas",
    size: 0.5,
    weight: 100,
    protein: 22.49,
    fat: 1.32,
    carbohydrates: 7.83,
    calories: 133,
    sugar: null,
  },
  {
    food: "Bakhsham",
    type: "Roti dan Sereal",
    serving: "potong",
    size: 1,
    weight: 10,
    protein: 1.2,
    fat: 0.95,
    carbohydrates: 6.84,
    calories: 41.2,
    sugar: null,
  },
  {
    food: "Burger Ayam",
    type: "Makanan Populer",
    serving: "satu sedang",
    size: 1,
    weight: 100,
    protein: 8.5,
    fat: 2.8,
    carbohydrates: 33.4,
    calories: 193,
    sugar: null,
  },
  {
    food: "Burger Daging",
    type: "Makanan Populer",
    serving: "satu sedang",
    size: 1,
    weight: 100,
    protein: 10,
    fat: 4.3,
    carbohydrates: 33.3,
    calories: 176.2,
    sugar: null,
  },
  {
    food: "Pringles Rasa Bawang",
    type: "Camilan",
    serving: "kotak kecil",
    size: 1,
    weight: 50,
    protein: 4.05,
    fat: 16.949,
    carbohydrates: 25.75,
    calories: 265.5,
    sugar: null,
  },
  {
    food: "Pringles Rasa Keju",
    type: "Camilan",
    serving: "kotak kecil",
    size: 1,
    weight: 50,
    protein: 3.49,
    fat: 18.5,
    carbohydrates: 25.31,
    calories: 275.5,
    sugar: null,
  },
  {
    food: "Brokoli",
    type: "Sayuran",
    serving: "gelas",
    size: 1,
    weight: 91,
    protein: 2.6,
    fat: 0.3,
    carbohydrates: 6,
    calories: 30.9,
    sugar: 1.5,
  },
  {
    food: "Biryani Ayam",
    type: "Makanan Populer",
    serving: "setengah gelas",
    size: 0.5,
    weight: 100,
    protein: 15.38,
    fat: 2.5,
    carbohydrates: 14,
    calories: 141.2,
    sugar: null,
  },
  {
    food: "Biryani Daging",
    type: "Makanan Populer",
    serving: "setengah gelas",
    size: 0.5,
    weight: 100,
    protein: 17.99,
    fat: 2.63,
    carbohydrates: 13.05,
    calories: 142.9,
    sugar: null,
  },
  {
    food: "Biskuit Keju",
    type: "Roti dan Sereal",
    serving: "satu potong",
    size: 1,
    weight: 1,
    protein: 0.1,
    fat: 0.25,
    carbohydrates: 0.58,
    calories: 5.03,
    sugar: null,
  },
  {
    food: "Biskuit Gandum",
    type: "Roti dan Sereal",
    serving: "satu potong",
    size: 1,
    weight: 2,
    protein: 0.17,
    fat: 0.41,
    carbohydrates: 1.3,
    calories: 9.46,
    sugar: null,
  },
  {
    food: "Biskuit Asin",
    type: "Roti dan Sereal",
    serving: "satu potong",
    size: 1,
    weight: 3,
    protein: 0.22,
    fat: 0.76,
    carbohydrates: 1.83,
    calories: 15.06,
    sugar: null,
  },
  {
    food: "Bawang Bombay",
    type: "Sayuran",
    serving: "gelas (cincang)",
    size: 1,
    weight: 160,
    protein: 1.8,
    fat: 0.2,
    carbohydrates: 14.9,
    calories: 64,
    sugar: 6.8,
  },
  {
    food: "Bebek Panggang Tanpa Kulit",
    type: "Daging",
    serving: "sebesar telapak tangan",
    size: 1,
    weight: 85,
    protein: 20,
    fat: 9.5,
    carbohydrates: 0,
    calories: 170.8,
    sugar: 0,
  },
  {
    food: "Bebek Panggang dengan Kulit",
    type: "Daging",
    serving: "sebesar telapak tangan",
    size: 1,
    weight: 85,
    protein: 16.1,
    fat: 24.1,
    carbohydrates: 0,
    calories: 286.4,
    sugar: 0,
  },
  {
    food: "Kentang",
    type: "Sayuran",
    serving: "satu sedang",
    size: 1,
    weight: 213,
    protein: 4.3,
    fat: 0.2,
    carbohydrates: 37.2,
    calories: 164,
    sugar: 1.7,
  },
  {
    food: "Kentang Goreng",
    type: "Makanan Populer",
    serving: "50 potong",
    size: 50,
    weight: 100,
    protein: 2.8,
    fat: 5.6,
    carbohydrates: 31.4,
    calories: 187,
    sugar: null,
  },
  {
    food: "Baqshamat",
    type: "Roti dan Sereal",
    serving: "gelas",
    size: 1,
    weight: 108,
    protein: 14.4,
    fat: 5.7,
    carbohydrates: 77.7,
    calories: 426.6,
    sugar: null,
  },
  {
    food: "Balalith",
    type: "Makanan Populer",
    serving: "setengah gelas",
    size: 0.5,
    weight: 100,
    protein: 5.5,
    fat: 6.1,
    carbohydrates: 30.4,
    calories: 199,
    sugar: null,
  },
  {
    food: "Bubur",
    type: "Sayuran",
    serving: "gelas",
    size: 1,
    weight: 33,
    protein: 0.3,
    fat: null,
    carbohydrates: 1.1,
    calories: 5,
    sugar: null,
  },
  {
    food: "Putih Telur",
    type: "Telur",
    serving: "putih telur",
    size: 1,
    weight: 33,
    protein: 3.6,
    fat: 0.1,
    carbohydrates: 0.2,
    calories: 15.8,
    sugar: 0.2,
  },
  {
    food: "Telur Angsa",
    type: "Telur",
    serving: "butir",
    size: 1,
    weight: 144,
    protein: 20,
    fat: 19.1,
    carbohydrates: 1.9,
    calories: 266.4,
    sugar: 1.4,
  },
  {
    food: "Telur Kalkun",
    type: "Telur",
    serving: "butir",
    size: 1,
    weight: 79,
    protein: 10.8,
    fat: 9.4,
    carbohydrates: 0.9,
    calories: 135.1,
    sugar: null,
  },
  {
    food: "Telur Gajih",
    type: "Telur",
    serving: "butir",
    size: 1,
    weight: 9,
    protein: 1.2,
    fat: 1,
    carbohydrates: null,
    calories: 14.2,
    sugar: null,
  },
  {
    food: "Telur Bebek",
    type: "Telur",
    serving: "butir",
    size: 1,
    weight: 70,
    protein: 9,
    fat: 9.6,
    carbohydrates: 1,
    calories: 129.5,
    sugar: 0.7,
  },
  {
    food: "Telur Ayam",
    type: "Telur",
    serving: "butir",
    size: 1,
    weight: 50,
    protein: 6.3,
    fat: 5,
    carbohydrates: 0.4,
    calories: 71.5,
    sugar: 0.4,
  },
  {
    food: "Telur Bubuk",
    type: "Telur",
    serving: "sendok teh",
    size: 1,
    weight: 5,
    protein: 2.4,
    fat: 2.2,
    carbohydrates: 0.1,
    calories: 30.8,
    sugar: null,
  },
  {
    food: "Telur Orak Arik dengan Susu",
    type: "Telur",
    serving: "butir",
    size: 1,
    weight: 61,
    protein: 6.8,
    fat: 7.4,
    carbohydrates: 1.3,
    calories: 101.9,
    sugar: 1.1,
  },
  {
    food: "Telur Rebus",
    type: "Telur",
    serving: "butir",
    size: 1,
    weight: 50,
    protein: 6.3,
    fat: 5.3,
    carbohydrates: 0.6,
    calories: 77.5,
    sugar: 0.6,
  },
  {
    food: "Telur Dadar",
    type: "Telur",
    serving: "butir",
    size: 1,
    weight: 46,
    protein: 6.3,
    fat: 7,
    carbohydrates: 0.4,
    calories: 90.2,
    sugar: 0.4,
  },
  {
    food: "Tabbouleh",
    type: "Sayuran",
    serving: "2 sendok makan",
    size: 2,
    weight: 28.35,
    protein: 1,
    fat: 2,
    carbohydrates: 2,
    calories: 30,
    sugar: null,
  },
  {
    food: "Apel",
    type: "Buah-buahan",
    serving: "satu sedang",
    size: 1,
    weight: 138,
    protein: 0.4,
    fat: 0.2,
    carbohydrates: 19.1,
    calories: 71.8,
    sugar: 14.3,
  },
  {
    food: "Apel Kering",
    type: "Buah-buahan",
    serving: "irisan",
    size: 1,
    weight: 98,
    protein: 0.9,
    fat: 0.3,
    carbohydrates: 64.6,
    calories: 238.1,
    sugar: 56,
  },
  {
    food: "Tikka Daging",
    type: "Makanan Populer",
    serving: "sebesar telapak tangan",
    size: 1,
    weight: 100,
    protein: 35.3,
    fat: 3.9,
    carbohydrates: 1.2,
    calories: 181,
    sugar: null,
  },
  {
    food: "Asam Jawa",
    type: "Buah-buahan",
    serving: "gelas",
    size: 1,
    weight: 120,
    protein: 3.4,
    fat: 0.7,
    carbohydrates: 75,
    calories: 286.8,
    sugar: 68.9,
  },
  {
    food: "Berry",
    type: "Buah-buahan",
    serving: "gelas",
    size: 1,
    weight: 123,
    protein: 1.5,
    fat: 0.8,
    carbohydrates: 14.7,
    calories: 64,
    sugar: 5.4,
  },
  {
    food: "Toks",
    type: "Camilan",
    serving: "potong",
    size: 1,
    weight: 57,
    protein: 3.08,
    fat: 13.4,
    carbohydrates: 37.45,
    calories: 272.46,
    sugar: null,
  },
  {
    food: "Tsarid",
    type: "Makanan Populer",
    serving: "tiga perempat gelas",
    size: 0.75,
    weight: 100,
    protein: 6.8,
    fat: 3.5,
    carbohydrates: 12.1,
    calories: 107,
    sugar: null,
  },
  {
    food: "Bawang Putih",
    type: "Sayuran",
    serving: "3 siung",
    size: 3,
    weight: 9,
    protein: 0.6,
    fat: null,
    carbohydrates: 3,
    calories: 13.4,
    sugar: 0.1,
  },
  {
    food: "Keju Parmesan Parut",
    type: "Susu",
    serving: "sendok teh",
    size: 1,
    weight: 5,
    protein: 1.9,
    fat: 1.4,
    carbohydrates: 0.2,
    calories: 21.6,
    sugar: null,
  },
  {
    food: "Keju Cheddar",
    type: "Susu",
    serving: "2 sendok makan",
    size: 2,
    weight: 28,
    protein: 7,
    fat: 9.3,
    carbohydrates: 0.4,
    calories: 112.8,
    sugar: 0.1,
  },
  {
    food: "Keju Halloumi",
    type: "Susu",
    serving: "gelas",
    size: 1,
    weight: 100,
    protein: 16.4,
    fat: 29.4,
    carbohydrates: 8.2,
    calories: 363,
    sugar: null,
  },
  {
    food: "Keju Kambing Keras",
    type: "Susu",
    serving: "2 sendok makan",
    size: 2,
    weight: 28,
    protein: 8.5,
    fat: 10,
    carbohydrates: 0.6,
    calories: 126.6,
    sugar: 0.6,
  },
  {
    food: "Keju Kambing Lunak",
    type: "Susu",
    serving: "2 sendok makan",
    size: 2,
    weight: 28,
    protein: 5.2,
    fat: 5.9,
    carbohydrates: 0.2,
    calories: 75,
    sugar: 0.2,
  },
  {
    food: "Keju Kambing Sedang",
    type: "Susu",
    serving: "2 sendok makan",
    size: 2,
    weight: 28,
    protein: 6,
    fat: 8.4,
    carbohydrates: 0.7,
    calories: 101.9,
    sugar: 0.7,
  },
  {
    food: "Keju Ricotta Rendah Lemak",
    type: "Susu",
    serving: "gelas",
    size: 1,
    weight: 124,
    protein: 14.1,
    fat: 9.8,
    carbohydrates: 6.4,
    calories: 171.1,
    sugar: 0.4,
  },
  {
    food: "Keju Ricotta Full Cream",
    type: "Susu",
    serving: "gelas",
    size: 1,
    weight: 124,
    protein: 14,
    fat: 16.1,
    carbohydrates: 3.8,
    calories: 215.8,
    sugar: 0.3,
  },
  {
    food: "Keju Feta",
    type: "Susu",
    serving: "2 sendok makan",
    size: 2,
    weight: 28,
    protein: 4,
    fat: 6,
    carbohydrates: 1.1,
    calories: 73.9,
    sugar: 1.1,
  },
  {
    food: "Keju Krim",
    type: "Susu",
    serving: "2 sendok makan",
    size: 2,
    weight: 15,
    protein: 0.9,
    fat: 5.1,
    carbohydrates: 0.6,
    calories: 51.3,
    sugar: null,
  },
  {
    food: "Keju Krim Bebas Lemak",
    type: "Susu",
    serving: "2 sendok makan",
    size: 2,
    weight: 28,
    protein: 4.4,
    fat: 0.3,
    carbohydrates: 2.1,
    calories: 29.4,
    sugar: 0.1,
  },
  {
    food: "Keju Krim Rendah Lemak",
    type: "Susu",
    serving: "2 sendok makan",
    size: 2,
    weight: 28,
    protein: 2.2,
    fat: 4.3,
    carbohydrates: 2.3,
    calories: 56.3,
    sugar: 0.1,
  },
  {
    food: "Keju Cottage <5% Lemak",
    type: "Susu",
    serving: "gelas",
    size: 1,
    weight: 226,
    protein: 23.4,
    fat: 0.7,
    carbohydrates: 15.1,
    calories: 162.7,
    sugar: 4.2,
  },
  {
    food: "Keju Mozzarella Full Cream",
    type: "Susu",
    serving: "2 sendok makan",
    size: 2,
    weight: 28,
    protein: 6.2,
    fat: 6.3,
    carbohydrates: 0.6,
    calories: 84,
    sugar: 0.3,
  },
  {
    food: "Keju Mozzarella Bebas Lemak",
    type: "Susu",
    serving: "2 sendok makan",
    size: 2,
    weight: 28,
    protein: 8.9,
    fat: 0,
    carbohydrates: 1,
    calories: 41.7,
    sugar: 0.4,
  },
  {
    food: "Keju Mozzarella Rendah Lemak",
    type: "Susu",
    serving: "2 sendok makan",
    size: 2,
    weight: 28,
    protein: 6.8,
    fat: 4.5,
    carbohydrates: 0.8,
    calories: 71.1,
    sugar: 0.3,
  },
  {
    food: "Jeruk Bali",
    type: "Buah-buahan",
    serving: "setengah sedang",
    size: 0.5,
    weight: 118,
    protein: 0.7,
    fat: 0.1,
    carbohydrates: 9.5,
    calories: 37.8,
    sugar: 8.2,
  },
  {
    food: "Wortel",
    type: "Sayuran",
    serving: "satu",
    size: 1,
    weight: 72,
    protein: 0.7,
    fat: 0.2,
    carbohydrates: 6.9,
    calories: 29.5,
    sugar: 3.3,
  },
  {
    food: "Wortel Kecil",
    type: "Sayuran",
    serving: "satu sedang",
    size: 1,
    weight: 10,
    protein: 0.1,
    fat: null,
    carbohydrates: 0.8,
    calories: 3.5,
    sugar: 0.5,
  },
  {
    food: "Jilab",
    type: "Makanan Populer",
    serving: "setengah gelas",
    size: 0.5,
    weight: 100,
    protein: 3.1,
    fat: 25,
    carbohydrates: 24,
    calories: 333,
    sugar: null,
  },
  {
    food: "Jambu Biji",
    type: "Buah-buahan",
    serving: "satu sedang",
    size: 1,
    weight: 90,
    protein: 2.3,
    fat: 0.9,
    carbohydrates: 12.9,
    calories: 61.2,
    sugar: 8,
  },
  {
    food: "Kelapa",
    type: "Kacang-kacangan",
    serving: "2 sendok makan",
    size: 2,
    weight: 45,
    protein: 1.5,
    fat: 15.1,
    carbohydrates: 6.9,
    calories: 159.3,
    sugar: 2.8,
  },
  {
    food: "Kelapa Kering",
    type: "Kacang-kacangan",
    serving: "2 sendok makan",
    size: 2,
    weight: 28,
    protein: 1.9,
    fat: 18.1,
    carbohydrates: 6.6,
    calories: 184.8,
    sugar: 2.1,
  },
  {
    food: "Biji Jagung",
    type: "Roti dan Sereal",
    serving: "gelas",
    size: 1,
    weight: 166,
    protein: 15.6,
    fat: 7.9,
    carbohydrates: 123.3,
    calories: 605.9,
    sugar: null,
  },
  {
    food: "Biji Gandum",
    type: "Roti dan Sereal",
    serving: "gelas",
    size: 1,
    weight: 192,
    protein: null,
    fat: null,
    carbohydrates: null,
    calories: 0,
    sugar: null,
  },
  {
    food: "Hasu",
    type: "Makanan Populer",
    serving: "setengah gelas",
    size: 0.5,
    weight: 100,
    protein: 2.9,
    fat: 7.1,
    carbohydrates: 14.9,
    calories: 135,
    sugar: null,
  },
  {
    food: "Susu Evaporasi",
    type: "Susu",
    serving: "6 sendok makan",
    size: 6,
    weight: 100,
    protein: 7,
    fat: 7.9,
    carbohydrates: 9.7,
    calories: 137,
    sugar: null,
  },
  {
    food: "Susu Domba",
    type: "Susu",
    serving: "gelas",
    size: 1,
    weight: 245,
    protein: 14.7,
    fat: 17.2,
    carbohydrates: 13.1,
    calories: 264.6,
    sugar: null,
  },
  {
    food: "Susu Kambing",
    type: "Susu",
    serving: "gelas",
    size: 1,
    weight: 244,
    protein: 8.7,
    fat: 10.1,
    carbohydrates: 10.9,
    calories: 168.4,
    sugar: 10.9,
  },
  {
    food: "Susu Cokelat",
    type: "Camilan",
    serving: "satu kaleng",
    size: 1,
    weight: 44,
    protein: 3.04,
    fat: 13.46,
    carbohydrates: 26.09,
    calories: 225.72,
    sugar: null,
  },
  {
    food: "Susu Cokelat Rendah Lemak",
    type: "Susu",
    serving: "gelas",
    size: 1,
    weight: 250,
    protein: 7.5,
    fat: 4.8,
    carbohydrates: 30.3,
    calories: 190,
    sugar: 23.9,
  },
  {
    food: "Susu Stroberi",
    type: "Susu",
    serving: "gelas",
    size: 1,
    weight: 266,
    protein: 8,
    fat: 8.2,
    carbohydrates: 32.7,
    calories: 234.1,
    sugar: null,
  },
  {
    food: "Susu Bubuk",
    type: "Susu",
    serving: "2 sendok makan",
    size: 2,
    weight: 32,
    protein: 8.4,
    fat: 8.5,
    carbohydrates: 12.3,
    calories: 158.7,
    sugar: 12.3,
  },
  {
    food: "Santan Kelapa",
    type: "Minuman",
    serving: "gelas",
    size: 1,
    weight: 240,
    protein: 5.5,
    fat: 57.2,
    carbohydrates: 13.3,
    calories: 552,
    sugar: 8,
  },
  {
    food: "Susu Rendah Lemak",
    type: "Susu",
    serving: "gelas",
    size: 1,
    weight: 244,
    protein: 8.1,
    fat: 4.8,
    carbohydrates: 11.4,
    calories: 122,
    sugar: 12.3,
  },
  {
    food: "Susu Full Cream",
    type: "Susu",
    serving: "sepertiga gelas",
    size: 0.3,
    weight: 100,
    protein: 3.5,
    fat: 3,
    carbohydrates: 5.5,
    calories: 64,
    sugar: null,
  },
  {
    food: "Susu Evaporasi Kaleng Skim",
    type: "Susu",
    serving: "2 sendok makan",
    size: 2,
    weight: 32,
    protein: 2.4,
    fat: 0.1,
    carbohydrates: 3.6,
    calories: 25,
    sugar: 3.6,
  },
  {
    food: "Susu Kental Manis (Kaleng)",
    type: "Susu",
    serving: "2 sendok makan",
    size: 2,
    weight: 38,
    protein: 3,
    fat: 3.3,
    carbohydrates: 20.7,
    calories: 122,
    sugar: 20.7,
  },
  {
    food: "Susu Skim",
    type: "Susu",
    serving: "gelas",
    size: 1,
    weight: 245,
    protein: 8.3,
    fat: 0.2,
    carbohydrates: 12.2,
    calories: 83.3,
    sugar: 12.5,
  },
  {
    food: "Burung Dara",
    type: "Daging",
    serving: "sebesar telapak tangan",
    size: 1,
    weight: 100,
    protein: 21.8,
    fat: 3.3,
    carbohydrates: 0,
    calories: 117.8,
    sugar: null,
  },
  {
    food: "Burung Dara Tanpa Kulit",
    type: "Daging",
    serving: "sebesar telapak tangan",
    size: 1,
    weight: 85,
    protein: 14.9,
    fat: 6.4,
    carbohydrates: 0,
    calories: 120.7,
    sugar: null,
  },
  {
    food: "Burung Dara Masak",
    type: "Daging",
    serving: "sebesar telapak tangan",
    size: 1,
    weight: 85,
    protein: 20.3,
    fat: 11,
    carbohydrates: 0,
    calories: 186.2,
    sugar: 0,
  },
  {
    food: "Burung Dara Goreng",
    type: "Daging",
    serving: "sebesar telapak tangan",
    size: 1,
    weight: 100,
    protein: 27.8,
    fat: 4.2,
    carbohydrates: 0,
    calories: 150,
    sugar: null,
  },
  {
    food: "Hummus",
    type: "Sayuran",
    serving: "sendok makan",
    size: 1,
    weight: 14,
    protein: 1.1,
    fat: 1.3,
    carbohydrates: 2,
    calories: 23.2,
    sugar: null,
  },
  {
    food: "Roti Putih",
    type: "Roti dan Sereal",
    serving: "seperempat roti",
    size: 0.25,
    weight: 25,
    protein: 1.9,
    fat: 0.8,
    carbohydrates: 12.7,
    calories: 66.5,
    sugar: 1.1,
  },
  {
    food: "Roti Putih Panggang",
    type: "Roti dan Sereal",
    serving: "seperempat roti",
    size: 0.25,
    weight: 22,
    protein: 2,
    fat: 0.9,
    carbohydrates: 12,
    calories: 64.5,
    sugar: 1,
  },
  {
    food: "Roti Gandum",
    type: "Roti dan Sereal",
    serving: "seperempat roti",
    size: 0.25,
    weight: 28,
    protein: 3.6,
    fat: 0.9,
    carbohydrates: 11.6,
    calories: 69.2,
    sugar: 1.6,
  },
  {
    food: "Roti Oat",
    type: "Roti dan Sereal",
    serving: "irisan kecil",
    size: 1,
    weight: 27,
    protein: 2.3,
    fat: 1.2,
    carbohydrates: 13.1,
    calories: 72.6,
    sugar: 0,
  },
  {
    food: "Roti Oat dengan Dedak",
    type: "Roti dan Sereal",
    serving: "irisan kecil",
    size: 1,
    weight: 30,
    protein: 3.1,
    fat: 1.3,
    carbohydrates: 11.9,
    calories: 70.8,
    sugar: 0,
  },
  {
    food: "Roti Keju",
    type: "Roti dan Sereal",
    serving: "potong",
    size: 1,
    weight: 66,
    protein: 4.69,
    fat: 12.08,
    carbohydrates: 28.84,
    calories: 237.6,
    sugar: null,
  },
  {
    food: "Roti Dedak",
    type: "Roti dan Sereal",
    serving: "seperempat roti",
    size: 0.25,
    weight: 36,
    protein: 3.2,
    fat: 1.2,
    carbohydrates: 17.2,
    calories: 89.3,
    sugar: 3.5,
  },
  {
    food: "Roti Roll Putih",
    type: "Roti dan Sereal",
    serving: "satu sedang",
    size: 1,
    weight: 28,
    protein: null,
    fat: null,
    carbohydrates: null,
    calories: 0,
    sugar: 2.2,
  },
  {
    food: "Roti Roll Gandum",
    type: "Roti dan Sereal",
    serving: "satu sedang",
    size: 1,
    weight: 36,
    protein: null,
    fat: null,
    carbohydrates: null,
    calories: 0,
    sugar: 0.6,
  },
  {
    food: "Roti Roll Burger",
    type: "Roti dan Sereal",
    serving: "satu",
    size: 1,
    weight: 43,
    protein: 4.1,
    fat: 1.9,
    carbohydrates: 21.3,
    calories: 120,
    sugar: 2.3,
  },
  {
    food: "Roti Perancis",
    type: "Roti dan Sereal",
    serving: "irisan kecil",
    size: 1,
    weight: 32,
    protein: 3.8,
    fat: 0.6,
    carbohydrates: 18.1,
    calories: 92.5,
    sugar: 1.1,
  },
  {
    food: "Khabishah",
    type: "Makanan Populer",
    serving: "setengah gelas",
    size: 0.5,
    weight: 100,
    protein: 3.5,
    fat: 6.3,
    carbohydrates: 58.6,
    calories: 305,
    sugar: null,
  },
  {
    food: "Khanfarush",
    type: "Makanan Populer",
    serving: "3 buah",
    size: 3,
    weight: 100,
    protein: 6.3,
    fat: 10.1,
    carbohydrates: 50.1,
    calories: 316,
    sugar: null,
  },
  {
    food: "Timun",
    type: "Sayuran",
    serving: "buah besar",
    size: 1,
    weight: 301,
    protein: 2,
    fat: 0.3,
    carbohydrates: 10.9,
    calories: 45.2,
    sugar: 5,
  },
  {
    food: "Timun Acar Asam",
    type: "Sayuran",
    serving: "satu irisan",
    size: 1,
    weight: 7,
    protein: 0.02,
    fat: 0.01,
    carbohydrates: 0.16,
    calories: 0.77,
    sugar: null,
  },
  {
    food: "Dal",
    type: "Makanan Populer",
    serving: "setengah gelas",
    size: 0.5,
    weight: 100,
    protein: 4.5,
    fat: 2.5,
    carbohydrates: 13.2,
    calories: 93,
    sugar: null,
  },
  {
    food: "Ayam",
    type: "Daging",
    serving: "sebesar telapak tangan",
    size: 1,
    weight: 85,
    protein: 18.2,
    fat: 2.6,
    carbohydrates: 0,
    calories: 101.2,
    sugar: 0,
  },
  {
    food: "Ayam Kaleng",
    type: "Daging",
    serving: "kaleng",
    size: 1,
    weight: 142,
    protein: 30.9,
    fat: 11.3,
    carbohydrates: 0,
    calories: 234.3,
    sugar: 0,
  },
  {
    food: "Tepung Oat",
    type: "Roti dan Sereal",
    serving: "2 sendok makan",
    size: 2,
    weight: 28,
    protein: 3.6,
    fat: 1.8,
    carbohydrates: 18.9,
    calories: 105,
    sugar: null,
  },
  {
    food: "Tepung Oat Masak",
    type: "Roti dan Sereal",
    serving: "gelas",
    size: 1,
    weight: 234,
    protein: 5.5,
    fat: 3.2,
    carbohydrates: 27.3,
    calories: 159.1,
    sugar: null,
  },
  {
    food: "Jagung Segar",
    type: "Sayuran",
    serving: "setengah gelas",
    size: 0.5,
    weight: 140,
    protein: 3.68,
    fat: 1.02,
    carbohydrates: 39.07,
    calories: 176.4,
    sugar: null,
  },
  {
    food: "Jagung Manis Kaleng",
    type: "Sayuran",
    serving: "gelas",
    size: 1,
    weight: 164,
    protein: 4.3,
    fat: 1.64,
    carbohydrates: 30.49,
    calories: 132.84,
    sugar: null,
  },
  {
    food: "Udang",
    type: "Daging",
    serving: "5 ekor",
    size: 5,
    weight: 100,
    protein: 19.7,
    fat: 0.8,
    carbohydrates: 0,
    calories: 87.1,
    sugar: null,
  },
  {
    food: "Udang Goreng",
    type: "Daging",
    serving: "3 ekor sedang",
    size: 3,
    weight: 85,
    protein: 18.17,
    fat: 10.43,
    carbohydrates: 9.74,
    calories: 205.71,
    sugar: null,
  },
  {
    food: "Sereal Jagung (manis)",
    type: "Roti dan Sereal",
    serving: "gelas",
    size: 1,
    weight: 38,
    protein: 2.014,
    fat: 0.532,
    carbohydrates: 34.24,
    calories: 148.58,
    sugar: null,
  },
  {
    food: "Sereal Jagung Biasa",
    type: "Roti dan Sereal",
    serving: "gelas",
    size: 1,
    weight: 28,
    protein: 1.84,
    fat: 0.199,
    carbohydrates: 24.22,
    calories: 102.2,
    sugar: null,
  },
  {
    food: "Labnah",
    type: "Susu",
    serving: "gelas",
    size: 1,
    weight: 100,
    protein: 12.9,
    fat: 10.8,
    carbohydrates: 1,
    calories: 154,
    sugar: null,
  },
  {
    food: "Daging Sapi Rebus (Giling)",
    type: "Daging",
    serving: "2 sendok makan",
    size: 2,
    weight: 85,
    protein: 20.45,
    fat: 17.6,
    carbohydrates: 0,
    calories: 245.65,
    sugar: null,
  },
  {
    food: "Daging Sapi Goreng (Giling)",
    type: "Daging",
    serving: "2 sendok makan",
    size: 2,
    weight: 85,
    protein: 20.33,
    fat: 19.2,
    carbohydrates: 0,
    calories: 260,
    sugar: null,
  },
  {
    food: "Daging Sapi Muda Masak",
    type: "Daging",
    serving: "3 potong kecil",
    size: 3,
    weight: 85,
    protein: 23.99,
    fat: 8,
    carbohydrates: 0,
    calories: 175,
    sugar: null,
  },
  {
    food: "Luqaimat",
    type: "Makanan Populer",
    serving: "5 buah",
    size: 5,
    weight: 100,
    protein: 3,
    fat: 9.5,
    carbohydrates: 44.4,
    calories: 275,
    sugar: null,
  },
  {
    food: "Almond",
    type: "Kacang-kacangan",
    serving: "2 sendok makan",
    size: 2,
    weight: 28,
    protein: 5.9,
    fat: 13.8,
    carbohydrates: 6.1,
    calories: 161,
    sugar: 1.3,
  },
  {
    food: "Lemon",
    type: "Buah-buahan",
    serving: "satu sedang",
    size: 1,
    weight: 58,
    protein: 0.6,
    fat: 0.2,
    carbohydrates: 5.4,
    calories: 16.8,
    sugar: 1.4,
  },
  {
    food: "Lemon Soda",
    type: "Minuman",
    serving: "satu setengah gelas",
    size: 1.5,
    weight: 355,
    protein: 0,
    fat: 0,
    carbohydrates: 38.4,
    calories: 149,
    sugar: null,
  },
  {
    food: "Air Kelapa",
    type: "Minuman",
    serving: "gelas",
    size: 1,
    weight: 240,
    protein: 1.7,
    fat: 0.5,
    carbohydrates: 8.9,
    calories: 45.6,
    sugar: 6.3,
  },
  {
    food: "Mangga",
    type: "Buah-buahan",
    serving: "satu sedang",
    size: 1,
    weight: 207,
    protein: 1.1,
    fat: 0.6,
    carbohydrates: 35.2,
    calories: 134.6,
    sugar: 30.6,
  },
  {
    food: "Mayones",
    type: "Lemak",
    serving: "sendok teh",
    size: 1,
    weight: 14.7,
    protein: 0.13,
    fat: 4.91,
    carbohydrates: 3.51,
    calories: 57.29,
    sugar: null,
  },
  {
    food: "Majbus Ayam",
    type: "Makanan Populer",
    serving: "setengah gelas",
    size: 0.5,
    weight: 100,
    protein: 17,
    fat: 2.39,
    carbohydrates: 17.2,
    calories: 158.36,
    sugar: null,
  },
  {
    food: "Majbus Daging",
    type: "Makanan Populer",
    serving: "setengah gelas",
    size: 0.5,
    weight: 100,
    protein: 16.89,
    fat: 3,
    carbohydrates: 16.87,
    calories: 166.5,
    sugar: null,
  },
  {
    food: "Zucchini Isi",
    type: "Makanan Populer",
    serving: "buah",
    size: 1,
    weight: 100,
    protein: 4.86,
    fat: 1.51,
    carbohydrates: 14.67,
    calories: 86.37,
    sugar: null,
  },
  {
    food: "Daun Anggur Isi",
    type: "Makanan Populer",
    serving: "4 buah",
    size: 4,
    weight: 100,
    protein: 7.47,
    fat: 2.73,
    carbohydrates: 16.11,
    calories: 125.2,
    sugar: null,
  },
  {
    food: "Muhallabiyah",
    type: "Makanan Populer",
    serving: "dua pertiga gelas",
    size: 0.67,
    weight: 100,
    protein: 2.9,
    fat: 2.9,
    carbohydrates: 17.6,
    calories: 108,
    sugar: null,
  },
  {
    food: "Kuah Ikan",
    type: "Makanan Populer",
    serving: "setengah",
    size: 0.5,
    weight: 100,
    protein: 7,
    fat: 5.8,
    carbohydrates: 0.5,
    calories: 82,
    sugar: null,
  },
  {
    food: "Jamur",
    type: "Sayuran",
    serving: "gelas",
    size: 1,
    weight: 70,
    protein: 2.2,
    fat: 0.2,
    carbohydrates: 2.3,
    calories: 15.4,
    sugar: 1.2,
  },
  {
    food: "Aprikot",
    type: "Buah-buahan",
    serving: "3 buah",
    size: 3,
    weight: 105,
    protein: 1.5,
    fat: 0.4,
    carbohydrates: 11.7,
    calories: 50.4,
    sugar: 9.7,
  },
  {
    food: "Aprikot Kering",
    type: "Buah-buahan",
    serving: "gelas",
    size: 1,
    weight: 65,
    protein: 2.2,
    fat: 0.3,
    carbohydrates: 40.7,
    calories: 156.6,
    sugar: 34.7,
  },
  {
    food: "Madhrobah",
    type: "Makanan Populer",
    serving: "setengah",
    size: 0.5,
    weight: 100,
    protein: 8.55,
    fat: 0.9,
    carbohydrates: 5.34,
    calories: 63.6,
    sugar: null,
  },
  {
    food: "Pasta Tomat",
    type: "Sayuran",
    serving: "168 gram (kaleng)",
    size: 1,
    weight: 170,
    protein: 7.3,
    fat: 0.8,
    carbohydrates: 32.1,
    calories: 139.4,
    sugar: 17.7,
  },
  {
    food: "Pasta Ayam",
    type: "Makanan Populer",
    serving: "setengah gelas",
    size: 0.5,
    weight: 100,
    protein: 17.9,
    fat: 1.9,
    carbohydrates: 10,
    calories: 129.7,
    sugar: null,
  },
  {
    food: "Pasta Matang",
    type: "Roti dan Sereal",
    serving: "gelas",
    size: 1,
    weight: 140,
    protein: 6.68,
    fat: 0.94,
    carbohydrates: 39.68,
    calories: 197.4,
    sugar: null,
  },
  {
    food: "Kacang Jagung",
    type: "Kacang-kacangan",
    serving: "2 sendok makan",
    size: 2,
    weight: 28,
    protein: 2.4,
    fat: 4.4,
    carbohydrates: 20.1,
    calories: 124.9,
    sugar: 0.2,
  },
  {
    food: "Kacang Campur Panggang",
    type: "Kacang-kacangan",
    serving: "1/8 gelas",
    size: 0.125,
    weight: 28,
    protein: 4.8,
    fat: 14.4,
    carbohydrates: 7.1,
    calories: 166.3,
    sugar: 2.5,
  },
  {
    food: "Kacang Campur Panggang dengan Minyak",
    type: "Kacang-kacangan",
    serving: "1/8 gelas",
    size: 0.125,
    weight: 28,
    protein: 4.7,
    fat: 15.8,
    carbohydrates: 6,
    calories: 172.8,
    sugar: 2.8,
  },
  {
    food: "Mandhi Ayam",
    type: "Makanan Populer",
    serving: "setengah gelas",
    size: 0.5,
    weight: 100,
    protein: 14.6,
    fat: 2.3,
    carbohydrates: 17.9,
    calories: 154.9,
    sugar: null,
  },
  {
    food: "Mandhi Daging",
    type: "Makanan Populer",
    serving: "setengah gelas",
    size: 0.5,
    weight: 100,
    protein: 11.9,
    fat: 1.9,
    carbohydrates: 20.34,
    calories: 147,
    sugar: null,
  },
  {
    food: "Pisang",
    type: "Buah-buahan",
    serving: "satu sedang",
    size: 1,
    weight: 118,
    protein: 1.3,
    fat: 0.4,
    carbohydrates: 27,
    calories: 105,
    sugar: 14.4,
  },
  {
    food: "Maid",
    type: "Daging",
    serving: "sebesar telapak tangan",
    size: 1,
    weight: 100,
    protein: 18.3,
    fat: 16.1,
    carbohydrates: 0,
    calories: 216.7,
    sugar: null,
  },
  {
    food: "Maid Panggang",
    type: "Daging",
    serving: "sebesar telapak tangan",
    size: 1,
    weight: 100,
    protein: 24.2,
    fat: 10.5,
    carbohydrates: 0,
    calories: 191.2,
    sugar: null,
  },
  {
    food: "Dedak Jagung",
    type: "Roti dan Sereal",
    serving: "gelas",
    size: 1,
    weight: 76,
    protein: 6.4,
    fat: 0.7,
    carbohydrates: 65.1,
    calories: 170.2,
    sugar: 0.2,
  },
  {
    food: "Dedak Beras",
    type: "Roti dan Sereal",
    serving: "gelas",
    size: 1,
    weight: 118,
    protein: 15.8,
    fat: 24.6,
    carbohydrates: 58.6,
    calories: 372.9,
    sugar: 5.4,
  },
  {
    food: "Dedak Gandum",
    type: "Roti dan Sereal",
    serving: "gelas",
    size: 1,
    weight: 58,
    protein: 9,
    fat: 2.5,
    carbohydrates: 37.4,
    calories: 125.3,
    sugar: 2.7,
  },
  {
    food: "Nafish",
    type: "Camilan",
    serving: "gelas",
    size: 1,
    weight: 11,
    protein: 0.99,
    fat: 3.09,
    carbohydrates: 6.29,
    calories: 55,
    sugar: null,
  },
  {
    food: "Nektar Pir",
    type: "Minuman",
    serving: "gelas",
    size: 1,
    weight: 248.59,
    protein: 0.67,
    fat: 0.05,
    carbohydrates: 34.6,
    calories: 134.24,
    sugar: null,
  },
  {
    food: "Nektar Aprikot",
    type: "Minuman",
    serving: "tiga perempat gelas",
    size: 0.75,
    weight: 250.99,
    protein: 0.93,
    fat: 0.23,
    carbohydrates: 36.12,
    calories: 140.55,
    sugar: null,
  },
  {
    food: "Nektarin",
    type: "Buah-buahan",
    serving: "satu sedang",
    size: 1,
    weight: 136,
    protein: 1.4,
    fat: 0.4,
    carbohydrates: 14.3,
    calories: 59.8,
    sugar: 10.7,
  },
  {
    food: "Mi Matang",
    type: "Roti dan Sereal",
    serving: "gelas",
    size: 1,
    weight: 160,
    protein: 7.6,
    fat: 2.35,
    carbohydrates: 39.74,
    calories: 212.8,
    sugar: null,
  },
  {
    food: "Hamour",
    type: "Daging",
    serving: "sebesar telapak tangan",
    size: 1,
    weight: 100,
    protein: 19.3,
    fat: 3.4,
    carbohydrates: 0.2,
    calories: 109.3,
    sugar: null,
  },
  {
    food: "Hamour dengan Nasi",
    type: "Daging",
    serving: "setengah gelas",
    size: 0.5,
    weight: 100,
    protein: 27.3,
    fat: 3.2,
    carbohydrates: 0,
    calories: 139.2,
    sugar: null,
  },
  {
    food: "Haris",
    type: "Makanan Populer",
    serving: "seperempat gelas",
    size: 0.25,
    weight: 100,
    protein: 9,
    fat: 0.7,
    carbohydrates: 8.3,
    calories: 76,
    sugar: null,
  },
  {
    food: "Asparagus",
    type: "Sayuran",
    serving: "gelas",
    size: 1,
    weight: 134,
    protein: 2.9,
    fat: 0.2,
    carbohydrates: 5.2,
    calories: 26.8,
    sugar: 2.5,
  },
  {
    food: "Daun Anggur",
    type: "Sayuran",
    serving: "gelas",
    size: 1,
    weight: 14,
    protein: 0.8,
    fat: 0.3,
    carbohydrates: 2.4,
    calories: 13,
    sugar: 0.9,
  },
  {
    food: "Yanam",
    type: "Daging",
    serving: "sebesar telapak tangan",
    size: 1,
    weight: 100,
    protein: 17.9,
    fat: 10.4,
    carbohydrates: 0,
    calories: 164.7,
    sugar: null,
  },
  {
    food: "Yanam Panggang",
    type: "Daging",
    serving: "sebesar telapak tangan",
    size: 1,
    weight: 100,
    protein: 25.9,
    fat: 5.6,
    carbohydrates: 0,
    calories: 154.8,
    sugar: null,
  },
];
export default foodData;